import { useQuery } from "@tanstack/react-query";
import { getProjectSettings } from "../../api/apiProjectSettings";

export function useGetProjectSettings() {
    const { isLoading, data, error, refetch } = useQuery({
        queryKey: ["project-settings"],
        queryFn: getProjectSettings,
        retry: false,
    });

    const settingsData = data?.data || null;

    return { isLoading, error, settingsData, refetch };
}
